import { componentSizeMap } from '@jdesign-vue/constants'

import type { ComponentSize } from '@jdesign-vue/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
